import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bloomfieldConfig } from "./data";

export default function BloomfieldPage() {
  return <CityPageTemplate config={bloomfieldConfig} />;
}